import { Navigate, Outlet } from 'react-router-dom';
import { RequireAuth } from 'aws-auth-lib';
import Loader from '../component/Loader';

function GuestOnlyRoute() {
    const renderGuestRoute = () => <Outlet />;

    return (
        <RequireAuth action={renderGuestRoute} loader={<Loader />}>
            <Navigate to="/" replace />
        </RequireAuth>
    );
}

function AuthenticatedRoute() {
    const redirectToLogin = () => <Navigate to="/login" replace />;

    return (
        <RequireAuth action={redirectToLogin} loader={<Loader />}>
            <Outlet />
        </RequireAuth>
    );
}

export { AuthenticatedRoute, GuestOnlyRoute };
